export const API_HOST = process.env.REACT_APP_API_SERVER;
export const EASEEDESK_PREFIX = 'easeedesk';

export const FETCH_TICKETS = `${API_HOST}/api/${EASEEDESK_PREFIX}/tickets`;
export const FETCH_ATTACHMENTS = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/attachments/`;
export const TICKET_TABS = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/tabs/`;
export const TICKET_SUMMARY = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/summary/`;
export const FETCH_DEVICES = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/affected_devices/`;
export const FETCH_CUSTOM_FIELDS = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/custom_fields/`;
export const FETCH_COMMENTS = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/comments/`;
export const FETCH_RELATED = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/related/`;
export const FETCH_OPERATIONS = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/operations/`;
export const TAKE_OVER_TICKET = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/take_over`;
export const POST_QUICK_TICKET = `${API_HOST}/api/${EASEEDESK_PREFIX}/quick_ticket/create`;
export const POST_TICKET_COMMENT = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/comment/create`;
export const FETCH_TICKET_COMMENT = `${API_HOST}/api/${EASEEDESK_PREFIX}/ticket/comment/`;
export const FETCH_QUICK_FILTERS = `${API_HOST}/api/${EASEEDESK_PREFIX}/filters/quick`;
